import { useEffect } from "react";
import PropTypes from "prop-types";

interface RedirectProps {
    url: string;
}

export default function Redirect({ url }: RedirectProps) {
  useEffect(() => {
    window.location.replace(url);
  }, [url]);

  return <></>;
}

Redirect.propTypes = {
  url: PropTypes.string.isRequired
};
